"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapIntegrationProviders = void 0;

var _ramda = require("ramda");

var _constants = require("../../../constants");

var mapIntegrationProviders = (0, _ramda.cond)([[(0, _ramda.equals)('graph'), (0, _ramda.always)(_constants.OUTLOOK_INTEGRATION_NAME)], [(0, _ramda.equals)('google'), (0, _ramda.always)(_constants.GOOGLE_INTEGRATION_NAME)], [_ramda.T, _ramda.identity]]);
exports.mapIntegrationProviders = mapIntegrationProviders;